import { createSlice } from "@reduxjs/toolkit";
import { invitationGet } from "../API/invitationsAPI";

const invitationSlice = createSlice({
  name: "invitations",
  initialState: {
    type: "wedding",
    dataInv: [],
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(invitationGet.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(invitationGet.fulfilled, (state, { payload }) => {
        state.dataInv = payload;
        state.isLoading = false;
      })
      .addCase(invitationGet.rejected, (state) => {
        state.isLoading = false;
        state.dataInv = [];
      });
  },
});

export const selectInv = (state) => state.invitations;
export const invitationReducer = invitationSlice.reducer;
